import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from 'redux-persist/lib/storage/session';
import loginReducer from "./ducks/login/reducers";
import alertReducer from "./ducks/alert/reducers";
import dashboardReducer from "./ducks/dashboard/reducers";
import memberReducer from "./ducks/member/reducers";
import loyaltyReducer from "./ducks/loyalty/reducers";
import workflowReducer from "./ducks/workflow/reducers";
import passwordReducer from './ducks/password/reducers';
import commonReducer from './ducks/common/reducers';
import calculationReducer from "./ducks/calculation/reducers";
import paymentReducer from './ducks/payment/reducers';

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["login", "dashboard", "member"]
};

const appReducer = combineReducers({
  login: loginReducer,
  alert: alertReducer,
  dashboard: dashboardReducer,
  member: memberReducer,
  loyalty: loyaltyReducer,
  workflow: workflowReducer,
  password: passwordReducer,
  common: commonReducer,
  calculation: calculationReducer,
  payment: paymentReducer
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
